import { render } from "./SidebarNavigation.vue?vue&type=template&id=069ce021"
const script = {}

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__